import React, { useState, useEffect, useRef } from "react";
import { FaUser, FaCog, FaChevronDown, FaSignOutAlt, FaUserPlus, FaUsers, FaTimes, FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../style/Header.css";

const Header = ({ onMobileToggle, mobileOpen }) => {
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const headerRef = useRef(null);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      navigate("/login");
    }
  };


  const closeDropdowns = () => {
    setShowProfileMenu(false);
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        closeDropdowns();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header 
      className="professional-header" 
      ref={headerRef}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: window.innerWidth > 768 ? '0 24px' : '0 12px',
        height: window.innerWidth > 768 ? '70px' : '60px',
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        borderBottom: '2px solid #e2e8f0',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        position: 'relative',
        zIndex: 100,
        overflow: 'visible',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        flexWrap: 'nowrap',
        gap: '8px'
      }}
    >
      {/* Mobile Sidebar Toggle - Left side */}
      <div 
        className="mobile-sidebar-toggle"
        style={{
          display: window.innerWidth > 768 ? 'none' : 'flex',
          flex: '0 0 auto',
          order: 0
        }}
      >
        <button 
          className="sidebar-toggle-btn" 
          onClick={onMobileToggle}
          aria-label="Toggle sidebar"
          aria-expanded={mobileOpen}
          style={{
            background: 'transparent',
            border: 'none',
            padding: '8px',
            borderRadius: '6px',
            cursor: 'pointer',
            color: '#475569',
            fontSize: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '40px',
            height: '40px'
          }}
        >
          {mobileOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Header Left - Empty on desktop, hidden on mobile */}
      <div 
        className="header-left"
        style={{
          display: 'none',
          flex: '0 0 auto'
        }}
      >
        {/* Empty as requested */}
      </div>

      {/* Header Center - Empty */}
      <div 
        className="header-center"
        style={{
          flex: '1',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {/* Empty space */}
      </div>

      {/* Admin User Section - Right */}
      <div 
        className="header-right"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flex: '0 0 auto',
          minWidth: 'fit-content'
        }}
      >
        
        <div className="user-profile">
          <div 
            className="user-avatar" 
            onClick={() => setShowProfileMenu(!showProfileMenu)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 12px',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              backgroundColor: showProfileMenu ? '#f8f9fa' : 'transparent',
              border: showProfileMenu ? '1px solid #e9ecef' : '1px solid transparent',
              position: 'relative'
            }}
            onMouseEnter={(e) => {
              if (!showProfileMenu) {
                e.target.style.backgroundColor = '#f8f9fa';
                e.target.style.borderColor = '#e9ecef';
              }
            }}
            onMouseLeave={(e) => {
              if (!showProfileMenu) {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.borderColor = 'transparent';
              }
            }}
          >
            <div style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              backgroundColor: '#007bff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '12px'
            }}>
              <FaUser />
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start'
            }}>
              <span style={{
                fontSize: '13px',
                fontWeight: '600',
                color: '#2c3e50',
                lineHeight: '1.2'
              }}>Admin</span>
            </div>
            <FaChevronDown 
              style={{
                fontSize: '12px',
                color: '#6c757d',
                transition: 'transform 0.2s ease',
                transform: showProfileMenu ? 'rotate(180deg)' : 'rotate(0deg)'
              }} 
            />
          </div>
          
          {showProfileMenu && (
            <div 
              className="profile-dropdown" 
              onClick={(e) => e.stopPropagation()}
              style={{
                position: 'absolute',
                top: '100%',
                right: '0',
                marginTop: '4px',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.15)',
                border: '1px solid #e9ecef',
                minWidth: '180px',
                zIndex: 1000,
                overflow: 'hidden',
                animation: 'slideDown 0.2s ease-out'
              }}
            >
              <div 
                onClick={() => { navigate("/dashboard/profile"); setShowProfileMenu(false); }} 
                className="dropdown-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  color: '#2c3e50',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f8f9fa';
                  e.target.style.color = '#007bff';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#2c3e50';
                }}
              >
                <FaUser style={{ fontSize: '14px', color: '#6c757d' }} />
                <span>My Profile</span>
              </div>
              <div 
                onClick={() => { navigate("/dashboard/create-user"); setShowProfileMenu(false); }} 
                className="dropdown-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '8px 12px',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  color: '#2c3e50',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f8f9fa';
                  e.target.style.color = '#28a745';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#2c3e50';
                }}
              >
                <FaUserPlus style={{ fontSize: '14px', color: '#6c757d' }} />
                <span>Create User</span>
              </div>
              <div 
                onClick={() => { navigate("/dashboard/view-users"); setShowProfileMenu(false); }} 
                className="dropdown-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '8px 12px',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  color: '#2c3e50',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f8f9fa';
                  e.target.style.color = '#17a2b8';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#2c3e50';
                }}
              >
                <FaUsers style={{ fontSize: '14px', color: '#6c757d' }} />
                <span>View Users</span>
              </div>
              <div 
                onClick={() => { navigate("/dashboard/settings"); setShowProfileMenu(false); }} 
                className="dropdown-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '8px 12px',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  color: '#2c3e50',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f8f9fa';
                  e.target.style.color = '#6c757d';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#2c3e50';
                }}
              >
                <FaCog style={{ fontSize: '14px', color: '#6c757d' }} />
                <span>Settings</span>
              </div>
              <div style={{ 
                height: '1px', 
                backgroundColor: '#e9ecef',
                margin: '4px 0'
              }}></div>
              <div 
                onClick={handleLogout} 
                className="dropdown-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '8px 12px',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease',
                  color: '#dc3545',
                  fontSize: '13px',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f8d7da';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                <FaSignOutAlt style={{ fontSize: '14px' }} />
                <span>Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
      
    </header>
  );
};

export default Header;
